'use client'

import React from 'react'
import { CSVExportProvider } from '~/scalis-components/core/csv-export/csv-export-provider'
import { useUserContext } from './user-provider'

interface CSVExportProviderWrapperProps {
  children: React.ReactNode
}

/**
 * Wrapper component that provides user context to CSVExportProvider
 * This ensures the CSV export functionality has access to the current user's ID
 */
export const CSVExportProviderWrapper: React.FC<CSVExportProviderWrapperProps> = ({ children }) => {
  const { user } = useUserContext()

  // Convert user ID to string if it exists
  const userId = user?.id ? String(user.id) : undefined

  return <CSVExportProvider userId={userId}>{children}</CSVExportProvider>
}
